module.exports = __webpack_public_path__ + "static/Longhorn100-logo-4671fc2c6f1d993e8ed641bffb25a491.png";